import { apiService } from './api.services'
import { buildPurchaseReceipt } from './purchaseReceipt'
import { formatEventDate, resolveEventTimeZone } from './event-timezone'

export default {
  data() {
    return { receiptInvoiceData: null, receiptInvoiceLoading: false, receiptInvoiceError: '', receiptInvoiceRequest: null, receiptInvoiceRequestId: '', receiptDataDisposed: false }
  },
  created() { this.loadReceiptInvoice() },
  beforeUnmount() { this.receiptDataDisposed = true },
  watch: {
    '$route.query.invoice'() { this.loadReceiptInvoice() },
    stripeInvoiceData(value) { if (value?.id) this.receiptInvoiceData = value },
  },
  computed: {
    receiptOrder() {
      const event = this.event || {}
      return buildPurchaseReceipt({
        event, invoice: this.receiptInvoiceData,
        provider: this.$route.query.provider, paymentType: this.$route.query.payment_type,
        date: formatEventDate(event.start_date, event, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }),
        shortDate: formatEventDate(event.start_date, event, { day: '2-digit', month: 'short', year: 'numeric' }),
        time: event.start_date ? formatEventDate(event.start_date, event, { hour: '2-digit', minute: '2-digit', hour12: false }) : '',
        timeZone: resolveEventTimeZone(event),
      })
    },
  },
  methods: {
    fetchReceiptInvoice(invoiceId) {
      const key = String(invoiceId)
      if (this.receiptInvoiceRequestId === key && this.receiptInvoiceRequest) return this.receiptInvoiceRequest
      this.receiptInvoiceRequestId = key
      this.receiptInvoiceRequest = apiService(`/api/invoices/${encodeURIComponent(key)}/`)
      return this.receiptInvoiceRequest
    },
    async loadReceiptInvoice() {
      this.receiptInvoiceData = null
      this.receiptInvoiceError = ''
      const id = String(this.$route.query.invoice || '')
      if (!/^[1-9]\d*$/.test(id) || this.$route.query.legacy === '1') return
      this.receiptInvoiceLoading = true
      const data = await this.fetchReceiptInvoice(id)
      if (this.receiptDataDisposed || String(this.$route.query.invoice || '') !== id) return
      if (data?.id && !data.err) this.receiptInvoiceData = data
      else this.receiptInvoiceError = 'No pudimos cargar el detalle de la compra. Puedes reintentarlo.'
      this.receiptInvoiceLoading = false
    },
    retryReceiptInvoice() {
      this.receiptInvoiceRequest = null
      return this.loadReceiptInvoice()
    },
  },
}
